<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

@if (category == null) {
    <span class="mdi mdi-help-circle-outline help-circle-outline icon"
        matTooltip="{{'endpoints.policy-compliance.unknown' | translate}}"
        matTooltipPosition="right"></span>
} @else if (category === PolicyCompliance.NON_COMPLIANT) {
    <span class="mdi mdi-alert-circle-outline alert-circle-outline icon"
        matTooltip="{{ 'endpoints.policy-compliance.non-compliant' | translate }}"
        matTooltipPosition="right"></span>
} @else if (category === PolicyCompliance.COMPLIANT) {
    <span class="mdi mdi-check-circle-outline check-circle-outline icon"
        matTooltip="{{ 'endpoints.policy-compliance.compliant' | translate }}"
        matTooltipPosition="right"></span>
} @else {
    <span class="mdi mdi-help-circle-outline help-circle-outline icon"
        matTooltip="{{'endpoints.policy-compliance.unknown' | translate}}"
        matTooltipPosition="right"></span>
}
